import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useDriverTerminalStream from '../../hooks/useDriverTerminalStream';

interface DriverTerminalPanelProps {
 deviceId?: number | null;
}

const DriverTerminalPanel = ({ deviceId }: DriverTerminalPanelProps) => {
 const { t } = useTranslation();
 const { status, name, error, frame, start } =
  useDriverTerminalStream(deviceId);

 const imgSrc = frame ? `data:${frame.mediaType};base64,${frame.base64}` : '';

 return (
  <Box
   sx={{
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minHeight: 160,
   }}
  >
   <Box
    sx={{
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     gap: 1,
    }}
   >
    <Typography sx={{ fontSize: 14, fontWeight: 500 }} noWrap>
     {name || t('dashboard.driverTerminal.placeholder')}
    </Typography>
    {!!deviceId && (
     <Button
      size="small"
      variant="outlined"
      onClick={start}
      disabled={status === 'loading'}
      title={t('dashboard.driverTerminal.refresh')}
     >
      ↻ {t('dashboard.driverTerminal.refresh')}
     </Button>
    )}
   </Box>

   {error && (
    <Typography sx={{ fontSize: 12, color: (th) => th.palette.kemek.red }}>
     {error}
    </Typography>
   )}

   {!deviceId ? (
    <Box
     sx={{
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: (th) => th.palette.kemek.gray,
      fontSize: 14,
     }}
    >
     {t('dashboard.driverTerminal.placeholder')}
    </Box>
   ) : (
    <Box
     sx={{
      flexGrow: 1,
      minHeight: 160,
      background: '#000',
      borderRadius: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
     }}
    >
     {imgSrc ? (
      <img
       src={imgSrc}
       alt={name || 'terminal'}
       style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
     ) : (
      <Typography sx={{ color: (th) => th.palette.kemek.gray, fontSize: 12 }}>
       {status === 'streaming' || status === 'loading' ? '…' : ''}
      </Typography>
     )}
    </Box>
   )}
  </Box>
 );
};

export default DriverTerminalPanel;
